import { Directive } from '@angular/core';

@Directive({
  selector: '[uiOverlayContent]',
  standalone: true
})
export class OverlayContentDirective {}
